module.exports = __webpack_public_path__ + "media/images/home/bursaries_icon-892ae243f4b7e7f2a152bebc1f31a9f9.svg";